<div class="panel-heading">
	<!-- Remove Button -->
	<button type="button" class="close" (click)="remove()" style="color: #ffffff; margin-left: 10px; display:block;">
		&times;
	</button>
	
	<!-- Minimize/Maximize Arrows -->
	<button (click)="showBody = !showBody" type="button" class="close"style="color: #ffffff; margin-left: 10px;">
		<i *ngIf="showBody" class="fa fa-angle-double-up"></i>
		<i *ngIf="!showBody" class="fa fa-angle-double-down"></i>
	</button>
	
	<!-- Title -->
	<h1 class="panel-title" style="display: inline-block; width: 90%">
		<div style="display: inline-block; width: 150px">
			<i class="fa fa-circle"></i>
			PARAMETER
		</div>
		<span style="margin-left: 20px; font-size: 16px;">
			{{getTitle()}}
		</span>
	</h1>
</div>

<div *ngIf="showBody" class="panel-body">
	<span>{{getParameterLabel()}}</span>
	<span class="dropdown">
		<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			{{getOperatorLabel(ruleCondition.operator)}}
			<span class="caret"></span>
		</button>
		<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto" >
			<li (click)="ruleCondition.operator = operator" *ngFor="let operator of entityOperators">
				<a class="ef">
					{{getOperatorLabel(operator)}}
				</a>
			</li>
		</ul>
	</span>

	<ng-container *ngIf="!isConditionOperator_HasPropertyWithValue(); then notHasPropertyWithValue else hasPropertyWithValue"></ng-container>

	<ng-template #notHasPropertyWithValue>
		<input class="form-control" type="text" [(ngModel)]="typeaheadValue" style="display: inline; width: 200px" 
			[typeahead]="entities"
			[typeaheadAsync]="true"
			typeaheadOptionField="name"
			(typeaheadLoading)="changeTypeaheadLoading($event)"
			(typeaheadOnSelect)="typeaheadOnSelect($event)"
			typeaheadOptionField="name" />
	</ng-template>

	<ng-template #hasPropertyWithValue>
		<!-- Selected Property -->
		<span class="dropdown">
				<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						{{getLabelForPropertyOption(selectedPropertyOption)}}
				</button>
				<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto" >
						<li *ngFor="let option of mPropertyOptions" (click)="selectedPropertyOption = option">
							<a class="ef">
								{{getLabelForPropertyOption(option)}}
							</a>
						</li>
					</ul>
		</span>

		<!-- Selected Property Operator-->
		<span class="dropdown">
			<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				{{getOperatorLabel(ruleCondition.propertyOperator)}}
				<span class="caret"></span>
			</button>
			<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto" >
				<li *ngFor="let propertyOperator of mPropertyOperators" (click)="ruleCondition.propertyOperator = propertyOperator">
					<a class="ef">
						{{getOperatorLabel(propertyOperator)}}
					</a>
				</li>
			</ul>
		</span>
		
		<!-- Selected Property Value -->
		<input class="form-control" type="text" [(ngModel)]="ruleCondition.value" style="display: inline; width: 250px"/>
	</ng-template>
</div>